export const SET_SUBJECT = '@fmc/contact/SET_SUBJECT';
export const SET_CATEGORY = '@fmc/contact/SET_CATEGORY';
export const RESET = '@fmc/contact/RESET';
